import React from 'react';
import { useTranslation } from "react-i18next";
import VolunteerEnhanced from '@/components/VolunteerEnhanced';

const VolunteerEnhancedPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <VolunteerEnhanced />
      </div>
    </div>
  );
};

export default VolunteerEnhancedPage;
